module.exports = __webpack_public_path__ + "img/middleCarouseImg3.296a25c8.jpg";